import { render } from "./RegistrationLayoutView.vue?vue&type=template&id=2bb36db0"
import script from "./RegistrationLayoutView.vue?vue&type=script&lang=js"
export * from "./RegistrationLayoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__